// Data table names
export const TABLES = {
  MARKET_UNIT_DISTRIBUTION: 'market_unit_distribution',
  EXTRA_DISCOUNT: 'Extra Discount',
  CALCULATION_METHOD: 'Calculation Method_blended',
  CUSTOM_PRICE_VALUES: 'CustomPriceValues_blended',
  PAINT_PROVIDED_TABLE: 'PaintProvidedTable',
  DISCOUNT_DISPLAY_OPTIONS: 'Discount Display Options',
  UNIT_DISCOUNT_OPTION: 'Unit Discount Option',
  SYSTEMUSER_PARTITIONED: 'systemuser_partitioned',
  PAINT_DISCOUNT: 'Paint Discount',
  CLEAN_DISCOUNT: 'Clean Discount',
  CARPET_CLEAN_DISCOUNT: 'Carpet Clean Discount',
  MAINTENANCE_DISCOUNT: 'Maintenance Discount',
  SAAS_BILLING_CYCLE: 'Fee - Platform Fee Billed',
  SAAS_UNIT_FEE: 'Fee - Fee per Unit',
  SAAS_UNIT_COUNT: 'Fee - Contracted Unit Count',
  SAAS_FEE_ENABLED: 'Fee-Platform Fee Activation',
};

// Data column names
export const COLUMNS = {
  COMPANY: 'company',
  EXTRA_DISCOUNT: 'Extra Discount',
  STATUS: 'Status',
  SETNAME: 'setname',
  PAINT_PROVIDED: 'PaintProvided',
  OPTION: 'Option',
  DOMAINNAME: 'domainname',
  VALUE: 'Value',
  SAAS_UNIT_FEE: 'Fee - Fee per Unit',
  SAAS_UNIT_COUNT: 'Contracted Unit Count',
};

// Visual IDs for data export
export const VISUAL_IDS = {
  COMPANY: {
    REPORT1: '7f23447694d27d7d611c',
    REPORT2: '8ed2964d59a681ce6b64',
  },
  EXTRA_DISCOUNT: {
    REPORT1: '64527809011b92f7f32c',
    REPORT2: 'e55549c9a3e7efbda5ca',
  },
  SET_ENABLED: {
    REPORT1: '655c8b579833dccdac38',
    REPORT2: '48db6035bf269aef4619',
  },
  SET_VALUE: {
    REPORT1: '8a37642665b4a81c187e',
    REPORT2: '17c37525a313c782940f',
  },
  PAINT_PROVIDED: {
    REPORT1: '63c5f4224546a09dc96e',
    REPORT2: '1235a839976c3cb0e136',
  },
  DISCOUNT_DISPLAY: {
    REPORT1: 'e8aa7ec1290e4b497527',
    REPORT2: 'e8aa7ec1290e4b497527',
  },
  UNIT_DISCOUNT_ENABLED: {
    REPORT1: '0e254eebeb29697070dd',
    REPORT2: 'f863b901c8ca4bda166e',
  },
  DOMAINNAME: {
    REPORT1: 'e60490dec0d359502941',
    REPORT2: '77a5a267a045c96a5e90',
  },
  SAAS_FEE_ENABLED: {
    REPORT1: '9daa61edd779782ca1c3',
    REPORT2: 'e93f4124675acc6e793c',
  },
  PAINT_DISCOUNT: '89670b72317ac5ec78b7',
  CLEAN_DISCOUNT: 'f397bda42c9b12407c0e',
  CARPET_CLEAN_DISCOUNT: '3b27e3113c848601dc42',
  MAINTENANCE_DISCOUNT: '5e5ef21de54c3f17b1db',
  CORE_TABLE: '6cf01fe98d4deaad619a',
  ADDONS_TABLE: '69be8e19f3a55c14a8b8',
  PAINT_ADDONS_REPAIR: '59980ac18478d2021b30',
  RESURFACING_ADDONS: 'd5c07df5bd3c7006a524',
  MAINTENANCE_ADDONS: '0d39afcdc75eac1b00aa',
  CLEANING_ADDONS: 'e08542ea106206c2b20e',
  CARPET_CLEANING_ADDONS: 'c6f7630d1a0b40820061',
  FLOORING: '8bd9c0928027323a0bb9',
  DEAL_MARGIN: '62442fd8193d107196a6',
  OVERALL_DISCOUNT: '093a15c28576e8083444',
  UNIT_DISCOUNT: 'c11635d240c010055447',
  SAAS_UNIT_COUNT: '61b56e89e9a0f6dd444f',
  SAAS_UNIT_FEE: '410927ba38dfa7d50b3c',
  SAAS_BILLING_CYCLE: '3adda5ae495ea271f191',

  // PDF Export Visual IDs
  SAAS_TOTAL_CARD: '53a6f4992d7f5d11c2f7',
  SAAS_UNIT_COUNT_CARD: '358003c86ee0f8cd5e64',
  SAAS_UNIT_FEE_CARD: '17da459f1e8bc3d3c72b',
  SAAS_BILLING_CYCLE_CARD: '603afd46963183b21ae1',
  PAINT_ADDONS: '3b4fee88ee4719f3c6ac',
  CORE_SERVICES: '2b75ed70a1595c4b5b50',
  EXTRA_UNIT_CONDITIONS: 'd786fb3b70b9eb0f17ef',
  EXTRA_ROOM: '9d0780a87dcc2ab91ee6',
  TOWNHOME: 'ea6ba9930c4e8bf2e838',
  DISCOUNT: '4adf676d4cbb92402108',
  MARKET_COUNT: '4bb99e973e57c9364b96',
  MARKETS: '4d951d048e09909298dd',
  REPAIR: '7ad0a891cd856c83a569',
  RESURFACING: '4f29fb2ceebdddca4645',
  MAINTENANCE: 'bced6932322871580b0d',
  CARPET_CLEANING: '2f4ed2e0334285e361e8',
  CLEANING: '844b946ca672a15e9d1d',
  PAINTING: 'c7f4f595dd4c6c878ed0',
};

// Other constants
export const MIN_DISCOUNT = 0;
